import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      *ngIf="visible"
      [class]="overlayClass"
      role="status"
      aria-live="polite"
      [attr.aria-label]="ariaLabel"
    >
      <div
        class="h-12 w-12 animate-spin rounded-full border-4 border-aav-outline-variant border-t-aav-primary"
      ></div>
    </div>
  `,
})
export class LoadingSpinnerComponent {
  @Input() visible = false;
  @Input() fixed = false;
  // Rótulo acessível: default em pt-BR para os usos que não têm i18n à mão; telas com
  // TranslateService passam a chave já traduzida.
  @Input() ariaLabel = 'Carregando';

  get overlayClass(): string {
    const base = 'inset-0 flex items-center justify-center bg-aav-surface/[0.64]';
    return this.fixed ? `fixed z-[10000] ${base}` : `absolute z-[1500] ${base}`;
  }
}
